import React from 'react';
import Note, { NoteType } from '@repo/utils/models/Note';
import { ReminderBadgeIcon } from '@repo/icons/Reminder';
import { NoteIconAndColorPicker, NoteLabelEditor } from '@repo/components/notes';
import { InteractionTypeBadge } from '@repo/components/badges';
import styles from './NoteTypeEditor.module.scss';

export function NoteTypeEditor({
  note,
  onChange,
  onLabelEnterKey,
}: {
  note: Note;
  onChange: (noteType: NoteType) => void;
  onLabelEnterKey?: () => void;
}) {
  if (note.isReadOnly) {
    return (
      <div className={styles.noteTypeEditor}>
        <InteractionTypeBadge interaction="contacts" />
        <div>Note via {note.importSource}</div>
      </div>
    );
  }

  return (
    <div className={styles.noteTypeEditor}>
      {note?.reminder?.date ? (
        <ReminderBadgeIcon date={note.reminder.date} />
      ) : (
        <NoteIconAndColorPicker noteType={note.type} updateNoteType={onChange} />
      )}
      <NoteLabelEditor
        label={note.type.label}
        updateLabel={(label) => onChange({ ...note.type, label })}
        onEnterKey={onLabelEnterKey}
      />
    </div>
  );
}
